import FadedLine from "./fadeLine";

export default FadedLine;